import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { TrendingDown, TrendingUp, Lightbulb } from "lucide-react";

interface MarketOpportunityCardProps {
  costReduction: string;
  marketValue: string;
}

export default function MarketOpportunityCard({
  costReduction,
  marketValue,
}: MarketOpportunityCardProps) {
  return (
    <Card className="shadow-lg h-full border border-slate-200 rounded-xl overflow-hidden">
      <CardHeader className="pb-3 pt-5 px-6 bg-slate-50 border-b border-slate-200">
        <CardTitle className="text-2xl font-semibold text-slate-800 flex items-center gap-2">
          <Lightbulb size={20} className="text-indigo-600" />
          Market Opportunity
        </CardTitle>
      </CardHeader>
      <CardContent className="p-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="p-2 bg-slate-50 rounded-lg">
            <div className="flex items-center gap-2 text-base font-medium text-slate-600 mb-2">
              <TrendingDown className="text-red-500" size={24} />
              Cost Reduction
            </div>
            <div className="text-4xl font-bold text-slate-800">
              {costReduction}
            </div>
            <p className="text-base text-slate-600 mt-2">
              Raw-ingredient saving 19%<br />
              processing overhead + 3%<br />
              Net ≈ 16% cost reduction
            </p>
          </div>
          <div className="p-2 bg-slate-50 rounded-lg">
            <div className="flex items-center gap-2 text-base font-medium text-slate-600 mb-2">
              <TrendingUp className="text-green-500" size={24} />
              Market Opportunity
            </div>
            <div className="text-4xl font-bold text-slate-800">
              {marketValue}
            </div>
            <p className="text-base text-slate-600 mt-2">
              Additional revenue<br />
              calculated based on 16%<br />
              savings and -0.88 price<br />
              elasticity of the demand
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
